export const EmptyRole = {
    role_ID: undefined,
    role_Name: '',
    role_Description: '',
    user_Added_by: undefined
}